import { KTIcon } from '@/_metronic/helpers'
import { FC, useState } from 'react'
import { useFilterReportBookingType } from '../../core/FilterReportBookingTypeProvider'

type Props = {
  closeModal: () => void
}

const FilterReportBookingTypeModalHeader: FC<Props> = ({closeModal}) => {
  const {updateFilterReportBookingTypeFormValue, filterReportBookingTypeFormValue} = useFilterReportBookingType()
  const [filterValueTemp, setFilterValueTemp] = useState(filterReportBookingTypeFormValue)

  const cancelModal = () => {
    updateFilterReportBookingTypeFormValue(filterValueTemp)
    closeModal()
  }

  return (
    <div className='modal-header'>
      <h2 className='fw-bolder'>Advanced Filter</h2>

      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-users-modal-action='close'
        onClick={cancelModal}
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>
    </div>
  )
}

export { FilterReportBookingTypeModalHeader }

